import { render, staticRenderFns } from "./kindChooseViewzlSeventh.vue?vue&type=template&id=edf1cbce&scoped=true"
import script from "./kindChooseViewzlSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewzlSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewzlSeventh.vue?vue&type=style&index=0&id=edf1cbce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf1cbce",
  null
  
)

export default component.exports